var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apolar-check-numbers"},[_c('ul',_vm._l((_vm.range),function(n){return _c('li',{key:n,class:_vm.getClass(n),attrs:{"data-number":n},on:{"click":function($event){return _vm.check_number(n)}}},[_vm._v("\n            "+_vm._s(_vm.label(n))+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }